<edit-header #editHeader />

<!-- Content -->
<div class="container-content" [class.sidebar-collapsed]="sessionsCollapsed()" [class.preview-open]="pdfPreviewOpen()" [class.preview-expanded]="pdfPreviewExpanded()" [class.with-rail]="showRail()" [class.mode-ai]="isAiMode()" [style.--line-spacing]="lineSpacing()" [style.--text-size]="textSize()" [style.--text-align]="textAlign()">
    <!-- Rail dos dois modos (manual · IA): fora do switch, à esquerda nos dois modos.
         Só existe com a feature liberada (flag `ai_edit_mode`). -->
    @if (showRail()) {
        <edit-mode-rail />
    }

    @if (isAiMode()) {
        <!-- Modo "Editar com IA": chat (flex) + a mesma prévia, a 42%. -->
        <ai-chat-panel animate.enter="mode-enter" />
    } @else {
        <!-- Section list -->
        <sections-list animate.enter="mode-enter" />

        @if (isQuote()) {
            <div class="main-with-tabs" animate.enter="mode-enter">
                <!-- Mesmo segmented control em pílula do feed (ra-tabs do DS), para as
                     duas telas alternarem listas do mesmo jeito. -->
                <div class="quote-tabs">
                    <ra-tabs
                        [items]="quoteTabs()"
                        [value]="quoteTab()"
                        (valueChange)="quoteTab.set($any($event))"
                        [ariaLabel]="'document.edit.quote.tab' | translate" />
                </div>

                <div class="main-pane">
                    @if (quoteTab() === 'quote') {
                        <quote-editor />
                    } @else {
                        <section-items />
                    }
                </div>
            </div>
        } @else {
            <!-- Section items -->
            <section-items animate.enter="mode-enter" />
        }
    }

    <!-- Prévia do PDF (coluna direita, toggle no header).
         Fica SEMPRE montado: a prévia começa junto com o editor, para o painel abrir
         pronto e para os traços de quebra de página existirem desde o início. Fechado,
         ele sai da tela por CSS (.collapsed) em vez de ser destruído, porque remover o
         iframe do DOM jogaria fora a paginação e ela teria de ser refeita do zero.
         No modo IA ela está sempre aberta: é ali que o usuário vê a IA trabalhar. -->
    <pdf-preview-panel [class.collapsed]="!pdfPreviewOpen() && !isAiMode()" [class.media-focus]="mediaFocus()" [chatMode]="isAiMode()">
        <!-- Modo IA: a etapa no cabeçalho da prévia e a ilha sobre a folha. -->
        @if (isAiMode()) {
            <ai-edit-preview-note previewHeaderNote />
        }
        @if (isAiMode()) {
            <ai-edit-preview-island previewOverlay />
        }
    </pdf-preview-panel>

    <!-- Formato da mídia (Foto, Grade, Vídeo) em modo foco: folha na esquerda por cima do
         editor escurecido, com a prévia acima do fundo e rolada até o item
         (MediaLookPanelService). -->
    <media-look-panel />
</div>

<!-- Troca de modo (manual ⇄ IA): overlay sobre o editor, abaixo do header, por 2 s ou
     até o modo de destino carregar. -->
<edit-mode-transition />

<!-- O retorno de salvamento ("Salvando…" / "Salvo") é o texto ao lado do título, no
     cabeçalho. A pílula do rodapé saiu em 2026-09-25: repetia a mesma informação. -->
